import {
  assign, endpoint, options, check, convert,
} from '../helpers';
import { User as action } from '../../redux/actions';

/**
 * Create a user account for each member in the user list
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const create = (properties) => {
  const props = assign(properties);
  const model = {
    Users: props.data.map(item => ({
      Name: item.name,
      Password: item.password,
      Surname: item.surname,
      Username: item.username,
    })),
  };

  fetch(endpoint('/create-users'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        if (props.dispatch) {
          props.dispatch(action.create(model.Users));
        }
        props.success(convert(response.Message));
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default create;
